import React from 'react';
import { useAuth } from '@/contexts/AuthContext';
import SuperAdminDashboard from './SuperAdminDashboard';
import AdminDashboard from './AdminDashboard';
import BranchManagerDashboard from './BranchManagerDashboard';
import SalesExecutiveDashboard from './SalesExecutiveDashboard';
import OperationsExecutiveDashboard from './OperationsExecutiveDashboard';
import RecoveryOfficerDashboard from './RecoveryOfficerDashboard';
import CashierDashboard from './CashierDashboard';
import AccountantDashboard from './AccountantDashboard';
import DataEntryDashboard from './DataEntryDashboard';

const MAP = {
  'Super Admin': SuperAdminDashboard,
  'Admin': AdminDashboard,
  'Branch Manager': BranchManagerDashboard,
  'Sales Executive': SalesExecutiveDashboard,
  'Operations Executive': OperationsExecutiveDashboard,
  'Recovery Officer': RecoveryOfficerDashboard,
  'Cashier': CashierDashboard,
  'Accountant': AccountantDashboard,
  'Data Entry Operator': DataEntryDashboard,
};

export default function RoleDashboard() {
  const { user } = useAuth();
  const Cmp = MAP[user?.role] || SuperAdminDashboard;
  return <Cmp />;
}
